import classNames from 'classnames/bind';
import React from 'react';
import ContentTypeTag, { ContentType } from '../ContentTypeTag';
import styles from './CoverageIndicator.module.scss';

interface CompanyCoverageProps {
  csCoverage: boolean;
  lfiCoverage: boolean;
  crCoverage: boolean;
  financialsCoverage: boolean;
  riskProductsCoverage: boolean;
  className?: string;
}

const cx = classNames.bind(styles);

const CoverageIndicator = ({
  csCoverage,
  lfiCoverage,
  crCoverage,
  financialsCoverage,
  riskProductsCoverage,
  className,
}: CompanyCoverageProps): React.ReactElement | null => {
  return (
    <div className={cx('body', className)} data-testid="coverage-indicator">
      {csCoverage && <ContentTypeTag contentType={ContentType.Research} short dataTestId="content-type-research" />}
      {crCoverage && <ContentTypeTag contentType={ContentType.Covenants} short dataTestId="content-type-covenants" />}
      {lfiCoverage && <ContentTypeTag contentType={ContentType.News} short dataTestId="content-type-news" />}
      {financialsCoverage && (
        <ContentTypeTag contentType={ContentType.Financials} short dataTestId="content-type-financials" />
      )}
      {riskProductsCoverage && (
        <ContentTypeTag contentType={ContentType.RiskProducts} short dataTestId="content-type-risk-products" />
      )}
    </div>
  );
};

export default CoverageIndicator;
